import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import wagonsService from "services/admin/wagonsService";

interface WagonFormProps {
  router: any;
  data: any;
}

const WAGON_TYPES = [
  "крытый",
  "платформа",
  "полувагон",
  "рефрижератор",
  "почтово-багажный",
];

const WagonForm = ({ router, data }: WagonFormProps) => {
  const {
    navigate,
    params: { id },
  } = router;
  const { wagon } = data;

  const fieldsWithData = [
    {
      key: "number",
      label: "Номер вагона",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "type",
      label: "Тип",
      inputType: inputTypeEnum.select,
      options: WAGON_TYPES.map((t) => ({ id: t, name: t })),
    },
    {
      key: "capacityKg",
      label: "Грузоподъёмность, кг",
      required: true,
      inputType: inputTypeEnum.number,
    },
    {
      key: "capacityVolumeM3",
      label: "Объём, м³",
      inputType: inputTypeEnum.number,
    },
    {
      key: "capacityPlaces",
      label: "Мест/паллет",
      inputType: inputTypeEnum.number,
    },
    {
      key: "tareWeightKg",
      label: "Тара, кг",
      inputType: inputTypeEnum.number,
    },
    {
      key: "ownership",
      label: "Владение",
      inputType: inputTypeEnum.select,
      options: [
        { id: "own", name: "Собственный" },
        { id: "rented", name: "Арендованный" },
      ],
    },
    {
      key: "isActive",
      label: "Активен",
      inputType: inputTypeEnum.checkbox,
    },
  ];

  const onSubmit = async (formValues: any) => {
    try {
      if (wagon) {
        await wagonsService.put(id, formValues);
        snack("Вагон обновлён успешно!");
      } else {
        await wagonsService.post(formValues);
        snack("Вагон создан успешно!");
      }
      setTimeout(() => navigate(-1), 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={wagon ? "Редактирование вагона" : "Создание вагона"}>
      <AppForm
        onSubmit={onSubmit}
        data={wagon || { ownership: "own", isActive: true }}
        fields={fieldsWithData}
      />
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(WagonForm, (router: any) => {
    let requests: any = {};
    if (router.params.id) {
      requests["wagon"] = () => wagonsService.get(router.params.id);
    }
    return useLoadAll(requests);
  }),
);
